import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/streams", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/streams", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkDelete(Entitiestoremove) {
  return __request__("POST", "/streams/bulk_delete", Entitiestoremove, {}, {
    "Accept": []
  });
}
export function bulkPause(Streamstopause) {
  return __request__("POST", "/streams/bulk_pause", Streamstopause, {}, {
    "Accept": []
  });
}
export function bulkResume(Streamstoresume) {
  return __request__("POST", "/streams/bulk_resume", Streamstoresume, {}, {
    "Accept": []
  });
}
export function getByIndexSet(indexSetId) {
  return __request__("GET", `/streams/byIndex/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getEnabled() {
  return __request__("GET", "/streams/enabled", null, {}, {
    "Accept": ["application/json"]
  });
}
export function assignToIndexSet(indexSetId, JSONbody) {
  return __request__("PUT", `/streams/indexSet/${indexSetId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getNoSecurity() {
  return __request__("GET", "/streams/no_security", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc") {
  return __request__("GET", "/streams/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function getConnectedPipelinesForStreams(streamIds) {
  return __request__("POST", "/streams/pipelines", streamIds, {}, {
    "Accept": ["application/json"]
  });
}
export function getBystreamId(streamId) {
  return __request__("GET", `/streams/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(streamId, JSONbody) {
  return __request__("PUT", `/streams/${streamId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(streamId) {
  return __request__("DELETE", `/streams/${streamId}`, null, {}, {
    "Accept": []
  });
}
export function cloneStream(streamId, JSONbody) {
  return __request__("POST", `/streams/${streamId}/clone`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function pause(streamId) {
  return __request__("POST", `/streams/${streamId}/pause`, null, {}, {
    "Accept": []
  });
}
export function getConnectedPipelines(streamId) {
  return __request__("GET", `/streams/${streamId}/pipelines`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function resume(streamId) {
  return __request__("POST", `/streams/${streamId}/resume`, null, {}, {
    "Accept": []
  });
}
export function testMatch(streamId, JSONbody) {
  return __request__("POST", `/streams/${streamId}/testMatch`, JSONbody, {}, {
    "Accept": []
  });
}
